import React, { useEffect, useState } from "react";
import { Form, message, Row, Col, Skeleton } from "antd";
import { SaveButton, CancelButton, ModalComponent, trans, InputTime, InputTextArea, InputDate, SelectResourceList } from "@comps/components"
import { makeRequest, getErrorProps } from "@utils/helpers";
import { createDataReq, getRosterReq } from "../requests";
import { Commons, Const } from "../../../constants";
import RoasterView from "@mods/common/RoasterView";

import { convertTimeTotz } from '@comps/commonFunctions';
import dayjs from 'dayjs';
import { makeFieldLabel } from "@utils/fieldTooltips";
import { leaveTooltips } from "../../../common/leaveTooltips";
const langKey = Const["relaxationRequest"].lngKey
const fieldLabel = makeFieldLabel(leaveTooltips.relaxation, { namespace: "relaxation", label: (key) => trans(`${langKey}.${key}`) });
const formName = "createRelaxationRequest";
const CreateRelaxationRequest = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [roasterView, setRoasterView] = useState(null)
  const [shifts, setShifts] = useState({})
  const [selectedEmploymentId, setEmploymentId] = useState(null)
  const [loading, setloading] = useState(false);
  const [form] = Form.useForm()
  useEffect(() => {
    getEmployments()
    // eslint-disable-next-line
  }, []);


  const getEmployments = () => {
    if (props.source === 'timeSheet') {
      setloading(false)
      form.setFieldValue('date', dayjs(props.record.date))
      setEmploymentId(props.record.employment_id)
      getRoster(dayjs(props.record.date), props.record.employment_id)
    }

    if(props.api==='relaxationRequest'){
      setEmploymentId(props.authUser.employment_id)
    }
  }

  const onChangeEmployment=(id)=>{
    
   if( form.getFieldValue('date') && id){
    getRoster(form.getFieldValue('date'),id)
   };
    setEmploymentId(id)
  }
  const getRoster = (date, employmentId) => {
    if (date) {
      setRoasterView(null)
      const payload = { relaxation: { employment_id: employmentId, date: date.format('YYYY-MM-DD') } }
      makeRequest(setLoader, getRosterReq, payload, onGetRosterSuccess, onGetRosterSuccess);
    }
  }

  const onGetRosterSuccess = (response, data) => {
    
    setloading(false)
    if (data.shifts) {
      setRoasterView(<RoasterView record={ data } />)
      setShifts(data.shifts[convertTimeTotz(data.from_date).format('YYYYMMDD') + '-' + data.employments[0].id][0]);
      let start_time = data.shifts[convertTimeTotz(data.from_date).format('YYYYMMDD') + '-' + data.employments[0].id][0]['start']
      let end_time = data.shifts[convertTimeTotz(data.from_date).format('YYYYMMDD') + '-' + data.employments[0].id][0]['end']

      form.setFieldsValue({
        start_time: convertTimeTotz(start_time),
        end_time: convertTimeTotz(end_time),
      })
    }
  }

  const onSubmit = (data) => {
    const payload = { relaxation: { shift: shifts, employment_id: shifts.employment_id, date: data.date.format('YYYY-MM-DD'), start_time: data.start_time.second(0), end_time: data.end_time.second(0), reason: data.reason, employee_shift_id: shifts.id },api:props.api,filters:props.filters };
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
    setSaveLoader(true)
  }

  const onSuccess = (data, res) => {
    setSaveLoader(false)
    message.success("Saved successfully");
    props.onCompleted(data.relaxations.data);
    props.onSuccess(data)
  }

  const onError = (err, res) => {
    setSaveLoader(false)
    message.error(res.response.data.message);
  }
  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    <SaveButton loading={ saveLoader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];
  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------
  return (
    <ModalComponent top={ 20 } width={ 680 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Skeleton loading={ loading }>
        <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmit } scrollToFirstError>
          <Row gutter={ 20 }>
            {
              props.relaxationof === "company" || !props.source === 'timeSheet' ?
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="employment_id" rules={ rules.employment_id } label={ fieldLabel("employment_id", trans(`${langKey}.employment_id`)) }
                    className="da-mb-16"
                    { ...getErrorProps(errors['name']) } size="small"
                  >
                    <SelectResourceList type='employment' onChange={ (id) => onChangeEmployment(id) } />
                  </Form.Item>
                </Col>
                : ''
            }
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="date" rules={ rules.date } label={ fieldLabel("date", trans(`${langKey}.date`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['date']) } size="small"
              >
                <InputDate onChange={ (e) => getRoster(e, selectedEmploymentId) } />
              </Form.Item>
            </Col>
          </Row>
          { roasterView }

          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="start_time" rules={ rules.start_time } label={ fieldLabel("start_time", trans(`${langKey}.start_time`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['start_time']) } size="small"
              >
                <InputTime placeholder={ trans(`${langKey}.start_time`) } />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="end_time" rules={ rules.end_time } label={ fieldLabel("end_time", trans(`${langKey}.end_time`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['end_time']) } size="small"
              >
                <InputTime placeholder={ trans(`${langKey}.end_time`) } />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="reason" rules={ rules.reason } label={ fieldLabel("reason", trans(`${langKey}.reason`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['reason']) } size="small"
              >
                <InputTextArea placeholder={ trans(`${langKey}.reason`) } />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Skeleton>
    </ModalComponent>
  )
}

export default CreateRelaxationRequest

const rules = {
  date: [
    { required: true, message: trans(`${langKey}.date.req`) },
  ],
  start_time: [
    { required: true, message: trans(`${langKey}.start_time.req`) },
  ],
  end_time: [
    { required: true, message: trans(`${langKey}.end_time.req`) },
  ],
  reason: [
    { required: true, message: trans(`${langKey}.reason.req`) },
  ],
  employment_id: [
    { required: true, message: trans(`${langKey}.employment_id.req`) },
  ],
};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}